import React from 'react';
import { Container } from 'react-bootstrap';
import { Route, Switch } from 'react-router-dom';
import { Welcome } from './Welcome';
import { CheckedIn } from './components/checkin/CheckedIn';
import { CheckedOut } from './components/checkout/CheckedOut';
import { ChooseAction } from './components/ChooseAction';
import { RecoilRoot } from 'recoil';
import './App.scss';
import { CheckinFailed } from './components/checkin/CheckedFailed';
import { ResetCache } from './components/system/ResetCache';
import { PreviousCheckin } from './components/checkins/PreviousCheckin';
import { SearchVisitor } from './components/checkins/SearchVisitor';
import { CheckinFlow } from './components/checkin/CheckinFlow';

function App() {
    return (
        <RecoilRoot>
            <Container fluid='sm'>
                <div className='top-container'>
                    <Switch>
                        <Route exact={true} path='/fail/:token' component={CheckinFailed} />
                        <Route exact={true} path='/checkin/:token' component={CheckinFlow} />
                        <Route exact={true} path='/checked/:token' component={CheckedIn} />
                        <Route exact={true} path='/checkout/:token' component={CheckedOut} />
                        <Route exact={true} path='/previous/:token' component={PreviousCheckin} />
                        <Route exact={true} path='/search/:token' component={SearchVisitor} />
                        <Route exact={true} path='/welcome/:token' component={ChooseAction} />
                        <Route exact={true} path='/reset/:token' component={ResetCache} />
                        <Route component={Welcome} />
                    </Switch>
                </div>
            </Container>
        </RecoilRoot>
    );
}

export default App;
